import { Box, Column, Divider, Row, Text } from '~/commonComponents';
import { ICandidateResumeEntity } from '~/domain/PermanentJobs';
import { formatExperienceDates, formatGraduationDate } from '../utils';
import OfficeBuildingIcon from '../../../images/office-building-icon.svg';
import AcademicCapIcon from '../../../images/academic-cap-icon.svg';

interface ICandidateResumeProps {
  resume: ICandidateResumeEntity;
}

export const CandidateResume = ({ resume }: ICandidateResumeProps) => {
  return (
    <Box marginTop={28} data-testid="candidate-resume">
      <Column gap={10} data-testid="about-section">
        <Text bold fontSize={20}>
          About {resume?.professionalFirstName}:
        </Text>
        <Text>{resume?.summary}</Text>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="experience-section">
        <Text bold fontSize={20}>
          Professional Experience:
        </Text>
        <Column gap={22}>
          {resume?.experiences?.map((experience, index) => (
            <Row key={`${experience.employerName}-${index}`} gap={4} data-testid="experience-item">
              <img src={OfficeBuildingIcon} alt="office building icon" width={24} height={24} />
              <Column>
                <Text fontSize={18}>
                  <Text bold fontSize={18}>
                    {experience.employerName}
                  </Text>{' '}
                  - {experience.title}
                </Text>
                <Text italic color="neutral_500">
                  {formatExperienceDates(
                    experience.startDate,
                    experience.endDate,
                    experience.isCurrentEmployer,
                  )}
                </Text>
              </Column>
            </Row>
          ))}
        </Column>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="education-section">
        <Text bold fontSize={20}>
          Highest Level of Education:
        </Text>
        {resume?.education?.map((education, index) => (
          <Row key={`${education.institutionName}-${index}`} gap={4} data-testid="education-item">
            <img src={AcademicCapIcon} alt="academic cap icon" width={24} height={24} />
            <Column>
              <Text bold fontSize={18}>
                {education.institutionName}
              </Text>
              <Text italic color="neutral_500">
                Graduation Date:{' '}
                {formatGraduationDate(education.graduationDate)}
              </Text>
            </Column>
          </Row>
        ))}
      </Column>
    </Box>
  );
};
